import { render, staticRenderFns } from "./ListTotauxVentes.vue?vue&type=template&id=e7c4e76e&"
import script from "./ListTotauxVentes.vue?vue&type=script&lang=ts&"
export * from "./ListTotauxVentes.vue?vue&type=script&lang=ts&"
import style0 from "./ListTotauxVentes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports